export default [
  // {
  //   label: 'Holiday Shop',
  //   dropdown: false,
  //   name: 'holiday',
  //   to: '/collections/holiday-shop',
  //   className: 'caramel'
  // },
  {
    label: 'New',
    dropdown: true,
    name: 'new',
    to: '/collections/new-arrivals',
  },
  {
    label: 'Furniture',
    dropdown: true,
    name: 'furniture',
    to: '/collections/furniture'
  },
  {
    label: 'Decor',
    dropdown: true,
    name: 'decor',
    to: '/collections/decor'
  },
  {
    label: 'Window',
    dropdown: true,
    name: 'window',
    to: '/c/home-decor/curtains'
  },
  // {
  //   label: 'Wallpaper',
  //   dropdown: true,
  //   name: 'wallpaper',
  //   to: '/collections/maximalist-wallpaper'
  // },
  {
    label: 'Bedding',
    dropdown: true,
    name: 'bedding',
    to: '/collections/all-bedding'
  },
  {
    label: 'Outdoor',
    dropdown: true,
    name: 'outdoor',
    to: '/collections/outdoorliving'
  },
  // {
  //   label: 'Holiday',
  //   dropdown: false,
  //   name: 'bedding',
  //   to: '/collections/holiday-shop'
  // },
  {
    label: 'Fabric',
    dropdown: true,
    name: 'fabric',
    to: '/c/fabric-by-the-yard/fabric-by-the-yard'
  },
  {
    label: 'Inspiration',
    dropdown: true,
    to: '/theinside-irl',
    name: 'inspiration'
  },
  // {
  //   label: 'Collaborations',
  //   dropdown: true,
  //   name: 'collaborations'
  // },
  {
    label: 'Free Swatches',
    dropdown: true,
    to: '/fabric-swatches',
    // name: '1-swatches'
    name: 'swatches'
  },
  {
    label: 'Trade',
    dropdown: true,
    to: '/design-trade-services',
    name: 'trade'
  },

];
